export default "/images/vendor/@coreui/icons/svg/flag/cif-ke.svg?cd220ce6ff142ce4a83b1a395e3016ef";